import { use, useActionState, useEffect } from "react";
import { useRef, useState } from "react";
import { User } from "../../../../models";
import { State, updateUser } from "../actions";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import FormError from "../../../../components/form-error";
import Select from "../../../../components/select";
import Toggle from "../../../../components/toggle";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";


export default function EditForm({ user }: { user: User }) {
  const initialState: State = {
    message: null,
    errors: {},
    defaultValues: {
      name: user.name,
      phone: user.phone,
      status: user.status,
      role: user.role,
      
    },
  };
  const updateUserWithId = updateUser.bind(null, user.id|| "");
  const [state, formAction, isPending] = useActionState(updateUserWithId, initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
  setIsSubmitting(isPending);
  }, [isPending]);
  
  useEffect(() => {
    if (state.success) 
      navigate("/admin/users");
  }, [state.success]);
  return (
    <form
      ref={formRef}
      className="space-y-6 max-w-3xl text-left"
      action={formAction}
      
    > 
      <FormBody>
        <div className="mb-4">
          <Label htmlFor="name">User Name</Label>

          <div className="relative">
            <Input
            readOnly
              id="name"
              name="name"
              type="text"
              placeholder="Enter user name"
              aria-describedby="name-error"
              defaultValue={state.defaultValues.name || user.name}
            ></Input>
            <FormError id="name-error" message={ state.errors?.name }></FormError>
          </div>
        </div>

        <div className="mb-4">
          <Label htmlFor="email">User Phone</Label>
          <Input
          readOnly
            id="phone"
            name="phone"
            type="text"
            placeholder="Enter user phone"
            aria-describedby="phone-error"
            defaultValue={state.defaultValues?.phone || user.phone}
            required
          ></Input>
          <FormError id="email-error" message={state.errors?.phone}></FormError>
        </div>

        <div className="mb-4">
          <Label htmlFor="role">User Role</Label>
          <Select
            id="role"
            name="role"
            items={[
              { id: "USER", name: "User" },
              { id: "ADMIN", name: "Admin" },
              { id: "SUPERADMIN", name: "Super Admin" },
            ]}
            defaultValue={ state.defaultValues.role  }           
            aria-describedby="role-error"
            placeholder="Select user role"
          ></Select>
          <FormError id="role-error" message={state.errors?.role}></FormError>
        </div>

        <div className="mb-4">
          <Label htmlFor="status">User Status</Label>
          <Select
            id="status"
            name="status"
            items={[
              { id: "ACTIVE", name: "Active" },
              { id: "PENDING", name: "Pending" },
              { id: "SUSPENDED", name: "Suspended" },
            ]}
            defaultValue={ state.defaultValues.status || user.status}
            aria-describedby="status-error"
            placeholder="Select user status"
          ></Select>
          <FormError
            id="status-error"
            message={state.errors?.status}
          ></FormError>
        </div>

        
      </FormBody>
       <div className="mt-6 flex justify-end gap-4">
        <Link to="/admin/users">
          <Button type="reset" disabled={isSubmitting}>
            Cancel
          </Button>
        </Link>          
        <Button type="submit" disabled={isSubmitting} className="min-w-[90px] " loading={isSubmitting}>
            Update        
        </Button>
      </div>
    </form>
  );
}
